import React, { useState, useReducer, useEffect, useRef} from 'react';
import { useHistory } from 'react-router-dom';
import Peer from 'skyway-js';
import { parse } from 'querystring';
import { UAParser } from 'ua-parser-js';

import BYE from "../images/button_icon_bye.svg";
import CALL from "../images/button_icon_tell.svg";
import CHECK from "../images/icon_check.svg";
import CHECK_HUMAN from "../images/icon_check_human.svg";
import Turtle from "../components/Turtle";
import Rabbit from "../components/Rabbit";
import HUMAN from "../images/icon_human.svg";
import MIC from "../images/icon_mic.svg";
import MUTE from "../images/icon_mute.svg";

const API_KEY = process.env.REACT_APP_SKYWAY_API_KEY;
const NAME_STATE = ["静止中", "歩行中", "ランニング中"];

export default function Call() {
	// useState
	const [peer, setPeer] = useState(null);
	const [room, setRoom] = useState(null);
	const [localStream, setLocalStream] = useState(null);
	const [ok, setOk] = useState(false);
	const [exerciseState,setExerciseState] = useState("walk");
	const [mute,setMute] = useState(true);
	const [current, setCurrent] = useState(0);
	const [speedByGeo, setSpeedByGeo] = useState(0);
	const [isGeo, setIsGeo] = useState(false);
	const [streams,setStreams] = useState(new Map());

	// useReducer
	//0静止,1歩行,2ランニング
	const [timer, setTimer] = useReducer((state,action) => state+action,0);
	const [positions, dispatch] = useReducer((state,action) => [...state,action],[]);
	const [calorie, setCalorie] = useReducer((state,action) => state+action,0);

	// useRef
	const refCurrent = useRef(current);
	const refIsGeo = useRef(isGeo);
	const refExerciseState = useRef(exerciseState);

	const history = useHistory();

	// UseEffect
	useEffect(()=>{
		UAcheck();
	},[])

	//位置情報の取得
	useEffect(()=>{
	  if(!isGeo) {
			return;
	  }
	  if(!navigator.geolocation) {
			console.log("geolocation is not supported");
			setIsGeo(false);
			return
	  }

	  let geo;
	  const f = async () => {
			try {
				geo = await navigator.geolocation.watchPosition((p) => {
					dispatch([p.coords.latitude,p.coords.longitude]);
					setSpeedByGeo(p.coords.speed);
				},e => {
					console.error(e);
					window.alert("位置情報を許可されない場合，一部機能のみの利用になります．\nデバイスの設定画面よりブラウザへの位置情報を許可して入り直してください．");
				},{
					enableHighAccuracy:true,
					maximumAge:0,
				});
			}catch(err) {
				console.warn('ERROR(' + err.code + '): ' + err.message);
				window.alert("位置情報を許可されない場合，一部機能のみの利用になります．\nデバイスの設定画面よりブラウザへの位置情報を許可して入り直してください．");
				setIsGeo(false);
			};
	  }
	  f();

	  return () => {
			if(geo !=null){
				navigator.geolocation.clearWatch(geo);
			}
	  }
	},[isGeo])

	//運動判定 geo
	useEffect(()=>{
		if(isGeo){
			let next_state = 0;
			if((0.5<speedByGeo) && (speedByGeo<3)){
				next_state=1;
			}else if(3<=speedByGeo){
				next_state=2;
			}
			setCurrent(next_state);
		}
	},[speedByGeo,isGeo])

	useEffect(() => {
		refCurrent.current = current;
	}, [current]);
	useEffect(() => {
		refIsGeo.current = isGeo;
	}, [isGeo]);
	useEffect(()=>{
		refExerciseState.current = exerciseState;
	},[exerciseState])

	//タイマー geo
	useEffect(()=>{
		const interval = setInterval(() => {
			if((refIsGeo.current)&&(refCurrent.current>0)){
				if(refCurrent.current===1){
					if(refExerciseState.current==="walk"){
						setTimer(1);
					}
					setCalorie(1/18);
				}else{
					setTimer(1);
					setCalorie(2/15);
				}
			}
		}, 1000);
		return () => {
			clearInterval(interval);
	  }
	},[])

	//muteの切り替え
	useEffect(() => {
		if(isGeo){
			if((exerciseState==="walk") && (current===0)){
				setMute(true);
			}else if((exerciseState==="run") && (current<=1)){
				setMute(true);
			}else{
				setMute(false);
			}
		}
		console.log(NAME_STATE[current]);
	},[current, isGeo, exerciseState])

	useEffect(() => {
		if (!ok) {
			return;
		}

		const f = async () => {
			// Permission取得
			const localStream = await window.navigator.mediaDevices.getUserMedia({ audio: true })
			setLocalStream(localStream);

			const peer = new Peer({
				key: API_KEY,
			});
			peer.on('open', (id) => {
				setPeer(peer);
			})
		}
		f();
	}, [ok])

	useEffect(() => {
		const f = async () => {
			if (peer == null) {
				return;
			}

			// Error処理必要
			// localStreamが取得できない場合やQueryがなかった場合など
			const roomID = parse(window.location.search.slice(1))["roomid"];

			const room = peer.joinRoom(roomID, {
				mode: "sfu",
				stream: localStream
			});

			setRoom(room);

			room.on('stream',stream => {
			  setStreams((prevMap) => new Map(prevMap.set(stream.peerId,stream)));
			})

			room.on("peerLeave",peerId=> {
			  setStreams((prevMap) => {
				const nextMap = new Map(prevMap);
				nextMap.delete(peerId);
				return nextMap;
			  });
			})
		}
		f();
	}, [peer])

	useEffect(() => {
		if (localStream == null) {
			return;
		}
		localStream.getAudioTracks().forEach(track => track.enabled = !mute);
	}, [mute,localStream])

	useEffect(() => {
	  if(!ok) {
			return;
	  }
	  const speakText = (mute)?"ミュートになったよ":"ミュートを解除したよ";
	  const utterance = new SpeechSynthesisUtterance(speakText);
	  speechSynthesis.speak(utterance);
	},[mute])

	function UAcheck(){
		const uaParser = new UAParser();
		const browser = uaParser.getBrowser().name;
		const os = uaParser.getOS().name;
		if(os.includes("Android")){
			if(!browser.includes("Chrome")){
				window.alert("【今お使いのブラウザでは使えません】\nAndroid：Chromeで開いてください\n");
				return false;
			}
		}else if(os.includes("iOS")){
			if(!browser.includes("Safari")){
				window.alert("【今お使いのブラウザでは使えません】\niPhone：Safariで開いてください");
				return false;
			}
		}else{
			window.alert("【今お使いのデバイスでは使えません】\niPhoneやAndroidなどのモバイル端末で開いてください\n");
			return false;
		}
		return true;
	}

	function disconnect() {
		if (room != null) {
			room.close();

		}
		if(localStream != null) {
		  localStream.getTracks().forEach(track => track.stop());
		}
		history.push({
      pathname: '/result',
			state: { calorie: calorie, timer: timer, positions: positions}
  	});
	}

	function start() {
		if(UAcheck()){
			setIsGeo(true);
			setOk(true);
		}
	}

	function setExercise(e) {
		setExerciseState(e.target.value);
	}

	function getTimeStr(time){
		const hour = Math.floor(time/3600);
		const minute = Math.floor((time-hour*3600)/60)
		const second = time-hour*3600-minute*60
		return ((hour<10)?"0"+hour:hour)+":"+((minute<10)?"0"+minute:minute)+":"+((second<10)?"0"+second:second);
	}

	const modalWindow = (ok) ? (null) : (
			<div className="modal_background">
				<div className="modal_window">
					<span className="modal_window_h1"><img src={CHECK} alt="✅"/>周囲の安全を確認しましょう</span>
					<img src={CHECK_HUMAN} alt="周囲を確認する人"/>
					<button className="button button-small" onClick={start}>
						<img src={CALL} alt="📞"/>
						通話を始める
					</button>
					<div className="modal_window_div">※ブラウザを閉じると動作しません</div>
				</div>
			</div>
	);

	const audioEl = []
	streams.forEach((stream,peerId) => {
	  audioEl.push(
		<AudioComponent stream={stream} />
	  );
	});

	return (
		<div className="main main-call">
			{modalWindow}
			<div className="call_exercise">
				<label className={exerciseState==="walk"?"checked":""}>
				  <input type="radio" value="walk" onChange={setExercise} checked={exerciseState === "walk"} />
				  {/*<img className="call_exercise_icon" src={TURTLE} alt="🐢"></img>歩く*/}
					<Turtle color={(exerciseState==="walk")?"#EDEFFC":"#2F80ED"}/>歩く
				</label>
				<label className={exerciseState==="run"?"checked":""}>
				  <input type="radio" value="run" onChange={setExercise} checked={exerciseState === "run"} />
				  {/*<img className="call_exercise_icon" src={RABBIT} alt="🐇"></img>走る*/}
					<Rabbit color={(exerciseState==="run")?"#EDEFFC":"#2F80ED"}/>走る
				</label>
			</div>
			{audioEl}
			<div className="call_time">⏰ 運動した時間<span>{getTimeStr(timer)}</span></div>
			<div className="call_status">
				<div className="call_mic" style={mute ? { color: "#BDBDBD" } : { color: "#2f80ed" }}><img src={mute ? MUTE : MIC} alt="🎤" />{mute ? "静止中" : "運動中"}</div>
				<div className="call_human_count"><img src={HUMAN} alt="👤" />参加人数 {streams.size + (ok)}人</div>
			</div>
			<button className="call_disconnect" onClick={disconnect}><img src={BYE} alt="通話を切る"/></button>
		</div>
	)
}

const AudioComponent = props => {
  const audioEl = useRef(null);
  const videoEl = useRef(null);
  useEffect(() => {
	audioEl.current.srcObject = props["stream"];
	videoEl.current.srcObject = props["stream"];
	audioEl.current.play();
	videoEl.current.play();
  },[])
  return (
	<div style={{display:"none"}}>
	  <audio ref={audioEl} />
	  <video ref={videoEl} />
	</div>
  )
}
